import { tncManagementApi } from "../../helpers/api/tnc/tnc.api";

export const TncManagementService = {
  getTnc,
  uploadTnc,
  updateTnc,
  deleteTnc,
  previewTnc
};

async function getTnc() {
  return await tncManagementApi.getTnc();
}

async function previewTnc(tncId) {
  return await tncManagementApi.previewTnc(tncId);
}

async function uploadTnc(file) {
  return await tncManagementApi.uploadTnc(file);
}

async function updateTnc(file, tncId) {
  return await tncManagementApi.updateTnc(file, tncId);
}

async function deleteTnc(tncId) {
  return await tncManagementApi.deleteTnc(tncId);
}

